export const environment = {

    production: true,
    development: false,


    mapbox: {
        accessToken: 'pk.eyJ1IjoibGVhc2VjbzIwMjQiLCJhIjoiY2x2cWg4NG40MGVhdjJqbnZnajZsOGdubCJ9.1MLYftcVzG3RVbt2DxKwnA',
        styleUrl: 'mapbox://styles/leaseco2024/cms1inc7500sc01qtbd63299x'
    },


    firebase: {
        apiKey: "AIzaSyCV0SNgz2s-kbTxn9mGSTkULk29tW8DDaM",
        authDomain: "blinkpic-f7456.firebaseapp.com",
        projectId: "blinkpic-f7456",
        storageBucket: "blinkpic-f7456.firebasestorage.app",
        messagingSenderId: "489628554261",
        appId: "1:489628554261:web:4326e93e7e47791a356a1c",
        measurementId: "G-PPLKJ2E9V0"
    },

    apiUrl: ''
};

